import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharedAssessmentDetailProps, SharedAssessmentDetailSliceProps } from "../../modules/user/self_assessment/type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const sharedAssessmentDetail = createAsyncThunk(
  "assessment/shared/detail",
  async (params: SharedAssessmentDetailSliceProps, storeActions) => {
    const url = `api/v1/user/assessment/detail?assessmentId=${params.assessmentId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sharedAssessmentDetailSlice = createSlice({
  name: "sharedAssessmentDetail",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as SharedAssessmentDetailProps | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sharedAssessmentDetail.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(sharedAssessmentDetail.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(sharedAssessmentDetail.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sharedAssessmentDetailSlice.actions;

export default sharedAssessmentDetailSlice;
